export default __webpack_public_path__ + "e5c115edf9f4bb0fb60da0a3ede1c6b4.png";